import { render, staticRenderFns } from "./todayMenu.vue?vue&type=template&id=4f8d1050&scoped=true"
import script from "./todayMenu.vue?vue&type=script&lang=js"
export * from "./todayMenu.vue?vue&type=script&lang=js"
import style0 from "./todayMenu.vue?vue&type=style&index=0&id=4f8d1050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d1050",
  null
  
)

export default component.exports